import React from 'react'
import GoogleIcon from '../../../../Assets/Images/icons/googleIcon'
import { makeStyles } from '@material-ui/styles'
import { styles } from './styles'
import { CONFIG } from '../../../../Config/config'
import { authorization } from '../../../../Module/Auth/Auth'
import { useWrappedPosthog } from '../../../../Components/PostHogProvider/hooks'

const socialProviders = {
  google: {
    social: 'Google',
    icon: <GoogleIcon />,
    param: 'GoogleLogin',
  },
}

export const SocialAuthButton = ({ type }) => {
  const posthog = useWrappedPosthog()
  const useStyles = makeStyles(styles)
  const classes = useStyles()

  const provider = socialProviders[type]

  const { social, icon, param } = provider

  const handleSocialAuth = () => {
    const width = 500
    const height = 500
    const left = window.innerWidth / 2 - width / 2
    const top = window.innerHeight / 2 - height / 2

    if (posthog) {
      posthog.capture('Clicked Continue with Google', {
        'event_action': 'User Clicks on the the button “Continue with Google“',
        'event_category': 'Social Auth',
      })
    }

    authorization.destroyPromofyAuthCookie()
    window.open(
      `${CONFIG.API_BASE_URL}/auth/${social.toLowerCase()}/authenticate`,
      param,
      `width=${width},height=${height},scrollbars=yes,resizable=yes,left=${left},top=${top}`,
    )
  }

  return (
    <div className={classes.buttonContainer} onClick={handleSocialAuth}>
      <div className={classes.iconContainer}>{icon}</div>
      <div className={classes.textContainer}>
        <p className={classes.text}>Continue with {social}</p>
      </div>
    </div>
  )
}
